import { Box, Stack, Typography } from '@mui/material';
import { StyledSectionBg } from './styles';

// ----------------------------------------------------------------------

type Props = {
  title?: string;
  children: React.ReactNode;
};

export default function LoginLayout({ children, title }: Props) {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <StyledSectionBg />

      <Stack spacing={10} paddingTop={15}>
        <Typography
          variant="h2"
          sx={{ textAlign: 'center', justifyContent: 'center', display: 'flex' }}
        >
          {title || 'Willkommen bei TerraIndividual'}
        </Typography>
        <Box display="flex" justifyContent="center" minWidth="100vw">
          {children}
        </Box>
      </Stack>
    </Box>
  );
}
